import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class TypeformService{
    public typeforms:Array<any> = [];
    private typeformPopups:Object = {};
    private ngUnsubscribe:Subject<void> = new Subject<void>();
    constructor() { }
    
    renderTypeforms(window:any):void {
        var self = this;
        this.ngUnsubscribe.next();

        for(var i=0; i < this.typeforms.length; i++)
        {
          var el = document.getElementById(this.typeforms[i].id);
          
          if(this.typeforms[i].mode && this.typeforms[i].mode == "popup")
          {
            if(!this.typeformPopups[this.typeforms[i].id])
            {
                this.typeformPopups[this.typeforms[i].id] = window.typeformEmbed.makePopup(this.typeforms[i].src, {
                    hideFooter: this.typeforms[i].header,
                    hideHeaders: this.typeforms[i].footer
                  });
            }
            
              var clickObserver = Observable.fromEvent(el, 'click').map((event:any) => {
                  event.preventDefault();
                  
                  return event.target.id
                }).takeUntil(this.ngUnsubscribe);
              clickObserver.subscribe(id => this.typeformPopups[id].open());
          }
          else{
            window.typeformEmbed.makeWidget(el, this.typeforms[i].src, {
                hideFooter: this.typeforms[i].header,
                hideHeaders: this.typeforms[i].footer,
                opacity: this.typeforms[i].opacity
              });
          }
          
        }
        this.typeforms = [];
      }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/util/typeform.service.ts